export const sendBrazeRequest = async (email: string, opts?: { tag?: string }) => {
  const resp = await fetch("/api/subscribe", {
    method: "POST",
    body: JSON.stringify({ email, ...(opts?.tag ? { tag: opts.tag } : {}) })
  })
  const response = await resp.json()

  return response
}
